import { useState } from 'react'

import { TablePaginationPageInput } from '../../../TablePagination'
import { Container } from '../../Container'

import * as styles from './PageInput.module.css'

function PageInput() {
  const [pagination, setPagination] = useState({
    count: 100,
    page: 0,
    pageCount: 7,
    pageSize: 15,
  })

  return (
    <Container label='TablePaginationPageInput'>
      <div>
        <TablePaginationPageInput value={pagination} onSubmit={setPagination} />
        <div className={styles.output}>
          {JSON.stringify(pagination, null, 4)}
        </div>
      </div>
    </Container>
  )
}

export default PageInput
